
import { CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ResizableSwappableCard } from "./ResizableSwappableCard";
import { COLORS } from "./utils";
import { D3PieChart, D3ResponsiveContainer } from "../../charts/D3ChartUtils";

interface ErrorDistributionChartProps {
  errorStats: Array<{ level: string; count: number }>;
  totalErrorCount: number;
  rearrangingEnabled?: boolean;
  onRemove?: (id: string) => void;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  onResize?: (id: string, newSize: 'small' | 'medium' | 'large' | 'xlarge') => void;
}

export function ErrorDistributionChart({ 
  errorStats, 
  totalErrorCount, 
  rearrangingEnabled = false,
  onRemove,
  size = 'medium',
  onResize
}: ErrorDistributionChartProps) {
  // Transform data for D3 charts
  const chartData = errorStats.map(item => ({
    name: item.level,
    value: item.count
  }));

  return (
    <ResizableSwappableCard 
      id="error-distribution" 
      size={size}
      showHandle={rearrangingEnabled}
      showResizeControl={rearrangingEnabled}
      onRemove={rearrangingEnabled ? onRemove : undefined}
      onResize={onResize ? (newSize) => onResize("error-distribution", newSize) : undefined}
    >
      <CardHeader>
        <CardTitle>Error Distribution</CardTitle>
        <CardDescription>Errors by severity level</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <D3ResponsiveContainer width="100%" height="100%">
            <D3PieChart
              data={chartData}
              colors={COLORS}
              valueFormatter={(value) => `${value} errors`}
              showLabels={true}
              donut={true}
            />
          </D3ResponsiveContainer>
        </div>
        <div className="mt-4">
          <p className="text-center text-sm font-medium">Total Errors</p>
          <p className="text-center text-2xl font-bold">{totalErrorCount}</p>
        </div>
      </CardContent>
    </ResizableSwappableCard>
  );
}
